import React from 'react';
import '../styles/header.css';
import logoImg from '../assets/images/HeaderLogo.png';
import LanguageSelector from '../components/LanguageSelector';
import { useTranslation } from 'react-i18next';
import { getContactUrl } from '../utils/contactUrl';

function Header() {
  const { t, i18n } = useTranslation();

  const contactUrl = getContactUrl(i18n.language);

  return (
    <header className="header">
      <img src={logoImg} alt="Logo" className="logo" />
      <div className="right-section">
        <a href={contactUrl} className="btn btn-info" target="_blank" rel="noopener noreferrer">
          {t('need_help')}
        </a>
        <LanguageSelector />
      </div>
    </header>
  );
}

export default Header;